// =============================================================================
// REACT & DOM
// =============================================================================
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactRouterDom from "react-router-dom";

// =============================================================================
// STATE MANAGEMENT & DATA FETCHING
// =============================================================================
import * as ReactRedux from "react-redux";
import * as ReduxToolkit from "@reduxjs/toolkit";

// =============================================================================
// FORMS & VALIDATION
// =============================================================================
import * as ReactHookForm from "react-hook-form";
import * as HookFormResolversZod from "@hookform/resolvers/zod";
import * as zod from "zod";

// =============================================================================
// UI COMPONENTS & LIBRARIES
// =============================================================================
import * as ReactSelect from "react-select";
import * as ReactLoadingSkeleton from "react-loading-skeleton";
import * as ReactHotToast from "react-hot-toast";
import * as Lightbox from "yet-another-react-lightbox";
import * as ReactRange from "react-range";
import * as ReactIndianaDragScroll from "react-indiana-drag-scroll";

// =============================================================================
// SLIDERS & ANIMATIONS
// =============================================================================
import * as Swiper from "swiper";
import * as SwiperModules from "swiper/modules";
import * as SwiperReact from "swiper/react";
import * as gsap from "gsap";
import * as ScrollTrigger from "gsap/ScrollTrigger";

// =============================================================================
// INTERNATIONALIZATION (i18n)
// =============================================================================
import * as i18next from "i18next";
import * as ReactI18next from "react-i18next";

// =============================================================================
// UTILITIES
// =============================================================================
import * as lazysizes from "lazysizes";
import * as quicklink from "quicklink";

// =============================================================================
// EXPORT VENDORS OBJECT
// This object maps exactly to the `globals` defined in your vite.config.ts
// =============================================================================
export const vendors = {
  React,
  ReactDOM,
  ReactRouterDom,
  ReactRedux,
  ReduxToolkit,
  ReactHookForm,
  HookFormResolversZod,
  zod,
  ReactSelect,
  ReactLoadingSkeleton,
  ReactHotToast,
  Lightbox,
  ReactRange,
  ReactIndianaDragScroll,
  Swiper,
  SwiperModules,
  SwiperReact,
  gsap,
  ScrollTrigger,
  i18next,
  ReactI18next,
  lazysizes,
  quicklink,
};

// Note: Because many standard WordPress plugins/themes assume React is globally available
// as `window.React`, it's a very good practice to explicitly assign it here as well,
// just in case they aren't using your `EcommerceCore` namespace.
if (typeof window !== "undefined") {
  window.React = React;
  window.ReactDOM = ReactDOM;
}
